import { render, staticRenderFns } from "./BudgetStatsDivider.vue?vue&type=template&id=3fe1440e&"
import script from "./BudgetStatsDivider.vue?vue&type=script&lang=js&"
export * from "./BudgetStatsDivider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports